import type { Testimonial } from '@/types'

import { PHOTO } from '@/constants/media'

export const VOICES = {
    benedikte: {
        quote: "Denne appen er helt genial! Om du er tømrer og gjør mange befaringer kommer du til å spare sykt mye tid.",
        name: 'Benedikte Tyskeberg',
        company: 'Tømrer B9',
        highlight: 'Raskere befaringer',
        image: PHOTO.benedikte
    },
    alexander: {
        quote: "Befaring blir plutselig veldig lett! Med skannen til Svenn får jeg opp alle målene jeg trenger for å raskt lage tilbud til kunden.",
        name: 'Alexander Bore',
        company: 'Snekker Bore',
        highlight: 'Kort vei til pristilbud',
        image: PHOTO.carpenterMitreSaw
    },
    georg: {
        quote: "For å kunne levere prosjekter av større art for oss, så er Svenn helt uunnværlig. Og uten Svenn Kalkulasjon hadde det ikke vært tid til overs.",
        name: 'Georg',
        company: 'Hh Håndverk AS',
        highlight: 'Vinner flere prosjekter',
        image: PHOTO.georg
    },
    georgKs: {
        quote: "For å kunne levere prosjekter av større art for oss, så er Svenn nå i dag helt uunnværlig. Uten Svenn hadde det ikke vært tid til overs.",
        name: 'Georg',
        company: 'Hh Håndverk AS',
        highlight: 'Frigjør tid til håndverket',
        image: PHOTO.georg
    },
    per: {
        quote: "Etter jeg begynte å bruke Svenn har jeg fått mer overskudd til å være ute og gjøre jobben ute på byggeplassen.",
        name: 'Per',
        company: 'Tømrer Per Slæprud',
        highlight: 'Mer tid på byggeplassen',
        image: PHOTO.carpenterNeonFrame
    },
    perKalk: {
        quote: "Nå føler jeg meg mye tryggere på at jobbene jeg priser blir lønnsomme, selv om jeg bare bruker en brøkdel av tiden det tok før.",
        name: 'Per',
        company: 'Tømrer Per Slæprud AS',
        highlight: '10+ timer spart per uke',
        image: PHOTO.carpenterNeonFrame
    },
    kenneth: {
        quote: "Svenn Kalkulasjon får terningkast 6 av meg. Latterlig enkelt å bruke og forbedres stadig. Dette er et must-have verktøy for alle tømrere.",
        name: 'Kenneth',
        company: 'Tømrer Juvet AS',
        highlight: 'Økte antall tilbud',
        image: PHOTO.rooferNailgun
    },
    tom: {
        quote: "At kalkulasjon skulle bli så lett, det hadde jeg aldri trodd. Vi vinner nå langt flere jobber enn før.",
        name: 'Tom',
        company: 'Prosjektmester AS',
        highlight: 'Vinner flere jobber',
        image: PHOTO.customerSnowSquare
    },
    tomPris: {
        quote: "Vi tjente inn kostnaden for Svenn allerede på første pristilbud – både på tid spart og nøyaktigheten i tilbudet.",
        name: 'Tom',
        company: 'Prosjektmester AS',
        highlight: '+2 MNOK i omsetning',
        image: PHOTO.customerSnowSquare
    },
    joakimPlan: {
        quote: "Svenn var mye enklere å ta i bruk enn andre løsninger vi testet, og ga oss mye mer kontroll på arbeidsdagen.",
        name: 'Joakim',
        company: 'Jar Bygg AS',
        highlight: 'Enkel å ta i bruk',
        image: PHOTO.craftsmanInsulation
    },
    joakimKs: {
        quote: "Med Svenn har avvikene gått ned og lønnsomheten gått opp. Svenn-appen er godt likt hos alle våre ansatte – og det er sjeldent.",
        name: 'Joakim',
        company: 'Jar Bygg AS',
        highlight: 'Lavere avvik, høyere lønnsomhet',
        image: PHOTO.craftsmanInsulation
    },
    joakimTimer: {
        quote: "Svenn var mye enklere å ta i bruk enn andre løsninger vi testet. Nå har vi fått mye mer kontroll på timeforbruk og fakturering.",
        name: 'Joakim',
        company: 'Jar Bygg AS',
        highlight: 'Kontroll på timene',
        image: PHOTO.craftsmanInsulation
    },
    robin: {
        quote: "Jeg sparer minst 10 timer i uken med Svenn.",
        name: 'Robin',
        company: 'Hundal Bygg AS',
        highlight: 'Full kontroll på uka',
        image: PHOTO.craftsmanBrickWall
    },
    robinTripletex: {
        quote: "En av fordelene med Svenn er integrasjonen med Tripletex. At disse to snakker sammen gjør at vi sparer mye tid.",
        name: 'Robin',
        company: 'Hundal Bygg AS',
        highlight: 'Sparer 10 timer i uka',
        image: PHOTO.craftsmanBrickWall
    },
    mikkelKs: {
        quote: "Vi sparer veldig mye tid med Svenn – så det er perfekt for oss. De har knekt koden og laget et verktøy som faktisk påvirker bunnlinja.",
        name: 'Mikkel',
        company: 'Løten Malerverksted AS',
        highlight: 'Sparer mye tid',
        image: PHOTO.craftsmanArmsCrossed
    },
    mikkelTimer: {
        quote: "Jeg vil si vi bruker mellom 10 og 15 timer mindre i uka på administrasjon etter at vi begynte å bruke Svenn.",
        name: 'Mikkel',
        company: 'Løten Malerverksted AS',
        highlight: '10+ timer spart per uke',
        image: PHOTO.craftsmanArmsCrossed
    },
    niclas: {
        quote: "Det er utrolig hvor mye man faktisk sparer med brukervennlige løsninger som Svenn.",
        name: 'Niclas',
        company: 'Bygg Trøndelag AS',
        highlight: 'Sparer tid med en enkel app',
        image: PHOTO.crewThreeLookingUp
    },
    bjornErik: {
        quote: "Kundeservicen og tempoet Svenn leverer er unikt! Med hjelp av Svenn fikk vi opp et fullstendig HMS-system samme dag vi tok kontakt – og tilsynet ble bestått med glans.",
        name: 'Bjørn Erik',
        company: 'NBT bygg AS',
        highlight: 'Tilsyn bestått med glans'
    },
    sigve: {
        quote: "Gjengen i Svenn er alltid lett tilgjengelig og leverer det de lover – hver eneste gang. De bærer HMS-sekken for meg, og det er en utrolig god følelse.",
        name: 'Sigve',
        company: 'Titan Bygg AS',
        highlight: 'Bærer HMS-sekken'
    },
    thorstein: {
        quote: "Med Svenn slipper jeg å være professor i HMS – den biten tar Svenn seg av. Å ha dem lett tilgjengelig på telefon gir meg en enorm trygghetsfølelse.",
        name: 'Thorstein',
        company: 'Fredriksten Entreprenør AS',
        highlight: 'Trygghet på telefon'
    }
} satisfies Record<string, Testimonial>
